import { useState, useEffect, useCallback } from 'react'
import {
  clearSessionToken,
  isTokenExpired,
  queryStringHasToken,
  redirectToAuthService,
  sessionHasValidToken,
  setSessionStorageAuth,
} from '../utils'
import { ROUTE_SESSION_EXPIRED } from '../../routes/constants'

const sanitizeUrl = () =>
  window?.history?.replaceState(null, document.title, window.location.pathname + window.location.search)

export const useProvideAuth = () => {
  const hasValidToken = sessionHasValidToken()
  const [isAuthenticated, setIsAuthenticated] = useState(hasValidToken)
  const handleLogout = useCallback(() => {
    clearSessionToken()
    window.location.href = process.env.LOGOUT_URL
  }, [])

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.hash)
    setIsAuthenticated((value) => {
      if (queryStringHasToken(searchParams) && !value) {
        setSessionStorageAuth(searchParams)
        sanitizeUrl()
        return true
      }
      if (hasValidToken) {
        sanitizeUrl()
      } else if (!isTokenExpired() && !window.location.href.includes(ROUTE_SESSION_EXPIRED)) {
        redirectToAuthService()
      }
      return hasValidToken
    })
  }, [hasValidToken])

  return {
    isAuthenticated,
    handleLogout,
  }
}
